import React from 'react';

import { HistoryOrder } from '../../index';

import { Title, OrderType, Amount, Vat, Tip, Row, Compliance } from './styles';
import { useI18n, useCurrency } from '~Hooks';
import { formatOrderType } from '~utilities';

export interface ReceiptDetailsProps {
  order: HistoryOrder | undefined;
}

export const ReceiptDetails = (props: ReceiptDetailsProps) => {
  const { i18n } = useI18n();

  const { order } = props;
  const currency = useCurrency();

  if (!order) return null;

  return (
    <>
      <Row>
        <Title>{i18n('History.OrderType')}</Title>
        <OrderType>{formatOrderType(order.type, i18n)}</OrderType>
      </Row>

      <Row>
        <Title>{i18n('History.Total')}</Title>
        <Amount>{currency.format(order?.payment?.amount)}</Amount>
      </Row>

      <Row>
        <Title>{i18n('History.VAT')}</Title>
        <Vat>{currency.format(order.vat)}</Vat>
      </Row>

      <Row>
        <Title>{i18n('History.Tip')}</Title>
        <Tip>{currency.format(order.payment.correctedTip ?? order.payment.tip)}</Tip>
      </Row>

      <Row>
        <Title small>{i18n('History.ComplianceID')}</Title>
        <Compliance>{order.complianceId}</Compliance>
      </Row>
    </>
  );
};
